module.exports = __webpack_public_path__ + "img/other-overheads.07886999.png";